import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Modal as AntModal,
  Badge,
  Input,
  Space,
  Button as AntButton,
  Row as AntRow,
  Form as AntForm,
  Select, Spin
} from "antd";
import Title from "antd/es/typography/Title";
import {
  LockOutlined,
  MinusCircleFilled,
  UserOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import HomeIcon from "@mui/icons-material/Home";
import PaidIcon from "@mui/icons-material/Paid";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import WidgetsIcon from "@mui/icons-material/Widgets";
import {
  markOR,
  printAsTextFile,
  printBase64,
  printOpenCashDrawer,
} from "../../Helpers/apiCalls/paymentAPI";
import {
  formatAmount,
  getRestoLogin,
  getRole,
  getSelectedTable,
  getToken,
  getUser,
  numberFormat,
  numberWithCommas,
  refreshPage,
  removeOrderId,
  removeUserSession,
  toastStyle,
} from "../../Helpers/Utils/Common";
import toast from "react-hot-toast";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { useReactToPrint } from "react-to-print";
import "../../cssFiles/Payment.css";
import { loginAuthorize, logoutUser } from "../../Helpers/apiCalls/authApi";
import CommonPrint from "../../Components/Print/CommonPrintReceipt";
import html2canvas from "html2canvas";
import {
  usePutRequest,
  usePostRequest,
} from "../../Helpers/hooks/usePostRequest";
import { UsePostRequest } from "../../Helpers/hooks/UsePostApiCall";
import { UseGetRequest } from "../../Helpers/hooks/GetRequests";
import { recordUserActivityLog } from "../../Helpers/apiCalls/authApi";

const AddSubmitButton = ({ form, isLoading, buttonText = "Submit" }) => {
  const [submittable, setSubmittable] = useState(false);
  const values = AntForm.useWatch([], form);
  React.useEffect(() => {
    form
      .validateFields({
        validateOnly: true,
      })
      .then(
        () => {
          setSubmittable(true);
        },
        () => {
          setSubmittable(false);
        }
      );
  }, [values]);

  return (
    <AntButton
      type="primary"
      htmlType="submit"
      disabled={!submittable}
      loading={isLoading}
    >
      {buttonText}
    </AntButton>
  );
};

export default function Payment() {
  const restoType = getRestoLogin();
  const localFetchSelectedTable = getSelectedTable();
  const userRole = getRole();
  const [discountForm] = AntForm.useForm();
  const { callPost, responseData, isLoading } = usePostRequest(() => {});
  const { callPut, putResponseData } = usePutRequest(() => {});
  const [modal, contextModal] = AntModal.useModal();
  const [superGrandTotal, setSuperGrandTotal] = useState(0);
  var tempChange = 0;
  const navigate = useNavigate();
  const printRef = useRef(null);
  const billoutRef = useRef();
  const reprintRef = useRef();
  const { tableID, orderID } = useParams();
  const [inactive, setInactive] = useState(true);
  const [discountTotal, setDiscountTotal] = useState(0);
  const [text, setText] = useState(["", "", "", ""]);
  const [isOpenPrice, setIsOpenPrice] = useState(false);
  const [isBillOut, setIsBillOut] = useState(false);
  const [openRate, setOpenRate] = useState(false);
  const [discountTypesCopy, setDiscountTypesCopy] = useState([]);
  const [doneModal, setDoneModal] = useState(false);
  const [orderInfo, setOrderInfo] = useState({});
  const [orderItems, setOrderItems] = useState([]);
  const [openCashDetails, setOpenCashDetails] = useState(true);
  const [openCard, setOpenCard] = useState(false);
  const [hasAuthenticationHistory, setHasAuthenticationHistory] =
    useState(false);
  const [openOthers, setOpenOthers] = useState(false);
  const [details, setDetails] = useState({
    bill_type: "full",
    remarks: "",
    type: "cash",
  });
  const [paymentDetails, setPaymentDetails] = useState({});
  const [paymentBreakdown, setPaymentBreakdown] = useState([]);
  const [coins, setCoins] = useState(0);
  const [action, setAction] = useState("");
  const [paxCount, setPaxCount] = useState(0);
  const [totalRemit, setTotalRemit] = useState(0);
  const [openDiscountModal, setOpenDiscountModal] = useState(false);
  const [openAuthorizeModal, setOpenAuthorizeModal] = useState(false);
  const [openDiscountDetails, setOpenDiscountDetails] = useState(false);
  const [chosenDiscounts, setChosenDiscounts] = useState([]);
  const [disabledDicounts, setDisabledDiscounts] = useState([]);
  const [currentDiscount, setCurrentDiscount] = useState({
    id: "",
    name: "",
    table_id: "",
    amount: "",
  });
  // const [isError, setIsError] = useState({
  //   id: false,
  //   name: false,
  // });
  const [openRatePercentage, setOpenRatePercentage] = useState(0);
  const [openPriceAmount, setOpenPriceAmount] = useState(0);
  const [currentSubtotal, setCurrentSubtotal] = useState(0);
  const [note, setNote] = useState("");
  const [noDetails, setNoDetails] = useState(false);
  const [openChangeModal, setOpenChangeModal] = useState(false);
  const { terminal } = useParams();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [disableClick, setDisableClick] = useState(false);
  const [multiplePayments, setMultiplePayments] = useState([]);
  const [currentPaymentData, setCurrentPaymentData] = useState({
    type: "cash",
  });
  const [totalPayment, setTotalPayment] = useState(0);
  const [serviceCharge, setServiceCharge] = useState(0);
  const [computedDiscount, setComputedDiscount] = useState({
    grand_total: 0,
    total_discount: 0,
    total_vat_exempt: 0,
  });
  const [userOptions, setUserOptions] = useState([]);
  // const [ipAddress, setIpAddress] = useState("");
  const [remainingBalance, setRemainingBalance] = useState(
    // parseFloat(superGrandTotal) - parseFloat(totalPayment)
    parseFloat(superGrandTotal-totalPayment).toFixed(2)
  );
  const [printingInProgress, setPrintingInProgress] = useState(false);
  const [foodServer, setFoodServer] = useState("");

  const [ws, setWs] = useState(null);
  const [orderCart, setOrderCart] = useState([]);

  useEffect(() => {
    setOrderCart([]);
    const socket = new WebSocket(window.socket_ip);
    setWs(socket);

    return () => {
      socket.close();
    };
  }, []);

  useEffect(() => {
    if (ws && ws.readyState === WebSocket.OPEN) {
      ws.send(JSON.stringify({grandTotal: superGrandTotal, subTotal: orderInfo.subtotal, serviceCharge: serviceCharge, computedDiscount: computedDiscount, subTotal: orderInfo.subtotal}));
    } else {
      console.warn("WebSocket is not open. Cannot send message.");
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [superGrandTotal,computedDiscount, serviceCharge, ws]);

  const handleRemoveProduct = () => {
    localStorage.removeItem("selected_table");
    localStorage.removeItem("order_show");
    localStorage.removeItem("food_server");
    localStorage.removeItem("product_show");
    localStorage.removeItem("is_attending");
    localStorage.removeItem("order_show");
    localStorage.removeItem("attending_transfer");
    localStorage.removeItem("show_add_item");
  }

  const handleRemoveActiveAttending = async () => {
    if(localFetchSelectedTable){
      await handleTableActivation(localFetchSelectedTable,"active",)
    }
  }

  async function handleTableActivation(passedTable, status) {
    recordUserActivityLog(`Payment Set ${passedTable.table_no} status to ${status}`);
    const payload = {
      token: getToken(),
      table_id: passedTable.id,
      status: status,
    };

    const response = await UsePostRequest(
      "qrcodes/mark_reserved",
      payload,
      false,
    );
    if (response.data) {

    } else {
      
    }
    handleRemoveProduct();
  }

  const deleteDiscount = (index) => {
    const newList = [...chosenDiscounts];
    newList.splice(index, 1);
    fetchApiDiscountComputation(newList);

    if (newList.length === 0) {
      setNote("no discount");
      setChosenDiscounts([]);
    } else {
      setDiscountTotal(discountTotal);
      setChosenDiscounts(newList);
    }
  };

  const handleDiscountClick = (data) => {
    recordUserActivityLog(`Clicked ${data.name} discount`);
    setOpenDiscountModal(false);
    setCurrentDiscount({
      ...currentDiscount,
      discount_id: data.id,
      discount_name: data.name,
      discount_open_amount: data.open_discount_amount,
      discount_rate: data.open_discount_rate,
      table_id: tableID,
      // amount:
      //   data.is_percentage === "1"
      //     ? parseFloat(currentSubtotal) * (parseFloat(data.percentage) / 100)
      //     : parseFloat(data.amount),
      percentage: data.percentage,
      is_percentage: data.is_percentage,
    });
    // senior citizen, pwd, max pwd/senior, employee
    if (
      data.id === "1" ||
      data.id === "2" ||
      data.id === "5" ||
      data.id === "4" ||
      data.id === ""
    ) {
      setOpenDiscountDetails(true);
    } else if (data.id === "7") {
      setIsOpenPrice(true);
    } else if (data.id === "8") {
      setOpenRate(true);
    } else {
      setNoDetails(true);
    }
  };

  const handleOpenDiscountClose = (type) => {
    if (type === "amount") {
      setIsOpenPrice(false);
      setOpenDiscountModal(true);
    } else if (type === "rate") {
      setOpenRate(false);
      setOpenDiscountModal(true);
    } else {
      setOpenDiscountModal(true);
      setCurrentDiscount({
        table_id: "",
        name: "",
        id: "",
      });
      setOpenDiscountDetails(false);
    }
  };

  const handleDiscountClose = (type) => {
    if (type === "cancel") {
      setCurrentDiscount({
        table_id: "",
        name: "",
        id: "",
      });
      setOpenDiscountDetails(false);
    } else {
      var arr = [...chosenDiscounts];
      arr.push(currentDiscount);
      // setGrandTotal(parseFloat(computeDiscount(arr)));
      setCurrentDiscount({
        table_id: "",
        name: "",
        id: "",
        amount: "",
      });
      setOpenDiscountDetails(false);
      setOpenRate(false);
      setIsOpenPrice(false);
      setChosenDiscounts(arr);
      fetchApiDiscountComputation(arr);
    }
    setOpenDiscountModal(false);
  };

  const handleTextChange = (e, index) => {
    const { value } = e.target;
    const list = [...text];
    list[index] = value;
    setText(list);
  };

  const handlePaymentSource = (e) => {
    const { value } = e.target;
    if (value === "Card") {
      recordUserActivityLog(`Clicked card payment type`);
      setDetails({ ...details, type: "card", card_type: "debit" });
      setCurrentPaymentData((prev) => ({
        // ...prev,
        approval_no: "",
        type: value?.toLowerCase(),
        paid_amount: remainingBalance,
        card_type: "debit",
      }));
      setOpenCard(true);
      // setOpenCheck(false);
      setOpenOthers(false);
      setOpenCashDetails(false);
      setTotalRemit(0);
    } else if (value === "Others") {
      recordUserActivityLog(`Clicked others payment type`);
      setDetails({ ...details, type: "others", other_source: "Gcash" });
      setCurrentPaymentData((prev) => ({
        // ...prev,
        other_reference_no: "",
        type: "others",
        paid_amount: remainingBalance,
        other_source: "Gcash",
      }));
      setOpenCard(false);
      // setOpenCheck(false);
      setOpenOthers(true);
      setOpenCashDetails(false);
      setTotalRemit(0);
    } else if (value === "Cash") {
      recordUserActivityLog(`Clicked cash payment type`);
      setDetails({ ...details, type: "cash" });
      setCurrentPaymentData((prev) => ({
        // ...prev,
        paid_amount: 0,
        type: "cash",
      }));
      setOpenCard(false);
      // setOpenCheck(false);
      setOpenOthers(false);
      setOpenCashDetails(true);
    } else if (value === "Select") {
      setDetails({ ...details, type: "" });
      setOpenCard(false);
      // setOpenCheck(false);
      setOpenOthers(false);
      setOpenCashDetails(false);
      setTotalRemit(0);
    }
  };

  const componentRefSummaryInvoice = useRef();
  const handlePrintSummaryInvoice = useReactToPrint({
    content: () => componentRefSummaryInvoice.current,
    pageStyle: () => "@page { size: letter; margin: 7mm; }",
    onAfterPrint: () => {
      setDoneModal(true);
    },
  });

  const exactAmount = (e) => {
    recordUserActivityLog(`Clicked exact amount`);
    setTotalRemit(e.target.value);
    setCurrentPaymentData((prev) => ({ ...prev, paid_amount: e.target.value }));
  };

  function handleAddPayment() {
    recordUserActivityLog(`Clicked save payment`);
    setMultiplePayments([...multiplePayments, currentPaymentData]);
    const tempTotalPayment =
      totalPayment + parseFloat(currentPaymentData.paid_amount);
    setTotalPayment(tempTotalPayment);
    setCurrentPaymentData({type: "cash"});
    setDetails({type: "cash"})
    setOpenCashDetails(true)
    setOpenCard(false)
    setOpenOthers(false)
  }

  const confirmPayment = () => {
    modal.confirm({
      content: "PERFORM BILL OUT FIRST",
    });
  };

  const isObjectEmpty = (obj) => {
    return Object.keys(obj).length === 0;
  };

  const submitPayment = () => {
    recordUserActivityLog(`Clicked submit payment`);
    var counter_pwd = 0,
      counter_senior = 0,
      discount_amt = 0,
      other_discount_count = 0;
    chosenDiscounts.map((data) => {
      discount_amt = discount_amt + parseFloat(data.amount);
      if (data.discount_id === "1") {
        counter_senior = counter_senior + 1;
      }
      if (data.discount_id === "2") {
        counter_pwd = counter_pwd + 1;
      }
      if (data.discount_name !== "pwd" && data.discount_name !== "senior") {
        other_discount_count = other_discount_count + 1;
        details["discount"] = discountTotal;
      }
    });
    details["pwd_count"] = counter_pwd;
    details["senior_citizen_count"] = counter_senior;
    details["other_count"] = other_discount_count;
    details["open_discount_rate"] = openRatePercentage;
    details["open_discount_amount"] = openPriceAmount;
    details["amount"] = computedDiscount?.new_total
      ? computedDiscount.new_total
      : superGrandTotal; //openCashDetails ? parseFloat(totalRemit) + parseFloat(coins) :
    details["total_cash"] = parseFloat(totalRemit) + parseFloat(coins);

    handleSettlement();
  };

  //Add Payment Multippl
  async function handleSettlement() {
    setOrderCart([]);
    if (!disableClick) {
      setDisableClick(true);
      const orderGrandTotal = superGrandTotal;

      const tempPayments = !isObjectEmpty(currentPaymentData)
        ? [...multiplePayments, currentPaymentData]
        : multiplePayments;
      const tempTotalPaid = parseFloat(
        tempPayments.reduce(
          (n, { paid_amount }) => n + parseFloat(paid_amount),
          0
        )
      ).toFixed(2);
      if (
        parseFloat(tempTotalPaid) >=
        parseFloat(parseFloat(orderGrandTotal).toFixed(2))
      ) {
        const cashPayments = tempPayments.filter(
          (payment) => payment.type === "cash"
        )[0];
        const cardPayments = tempPayments.filter(
          (payment) => payment.type === "card"
        )[0];
        const otherPayments = tempPayments.filter(
          (payment) => payment.type === "others"
        );
        const amtTypes = tempPayments.map((payment) => {
          return {
            type: payment.type,
            amount: payment.paid_amount,
            other_payment_details: payment.other_source,
            reference_no: payment.other_reference_no,
          };
        });


        const seniorDiscs = [];
        const pwdDiscs = [];
        const otherDiscs = [];

        chosenDiscounts.forEach((row) => {
          if (row.discount_id === "1" || row.discount_id === "5") {
            seniorDiscs.push(row);
          } else if (row.discount_id === "2") {
            pwdDiscs.push(row);
          } else if (
            row.discount_id === "4" ||
            row.discount_id === "7" ||
            row.discount_id === "8"
          ) {
            otherDiscs.push(row);
          }
        });
       

        const payload = {
          token: getToken(),
          bill_type: "full",
          types: tempPayments.map((payment) => payment.type),
          discount: computedDiscount.total_discount,
          pwd_count: details.pwd_count,
          senior_citizen_count: details.senior_citizen_count,
          other_discount_count: details.other_discount_count ?? 0,
          card_no: cardPayments?.approval_no,
          card_type: cardPayments?.card_type,
          change:
            parseFloat(tempTotalPaid - orderGrandTotal) >= 0
              ? tempTotalPaid - orderGrandTotal
              : parseFloat(tempTotalPaid - orderGrandTotal) * -1,
          card_expiry: "",
          card_bank: "",
          check_no: "",
          check_bank: "",
          check_date: "",
          amount_and_types: amtTypes,
          // other_source: otherPayments[0]?.other_source ?? "",
          // other_reference_no: otherPayments[0]?.other_reference_no ?? "",
          // other_amount: otherPayments[0]?.paid_amount ?? 0,
          // other_source: otherPayments?.map((row)=>row.other_source),
          // other_reference_no: otherPayments?.map((row)=>row.other_reference_no),
          // other_amount: otherPayments?.map((row)=>row.paid_amount),
          
          cash_amount: cashPayments?.paid_amount ?? 0,
          card_amount: cardPayments?.paid_amount ?? 0,
          check_amount: "",
          amount: details.amount,
          discount_ids: chosenDiscounts.map((data) => data.discount_id),
          open_discount_rate: details.open_discount_rate,
          open_discount_amount: details.open_discount_amount,
          service_charge: serviceCharge,
          senior_names: seniorDiscs.map((row) => row.name),
          senior: seniorDiscs.map((row) => row.id),
          pwd_names: pwdDiscs.map((row) => row.name),
          pwd: pwdDiscs.map((row) => row.id),
          other_names: otherDiscs.map((row) => row.name),
          others: otherDiscs.map((row) => row.id),
        };

        callPost(
          "payments/createMultiple/" + orderID,
          payload,
          false,
          restoType
        );
      } else {
        setDisableClick(false);
        toast.error("Insufficient Amount");
      }
    }
  }

  //Login Authorize for Discount
  async function handleLoginAuthentication() {
    const response = await loginAuthorize(
      username,
      password,
      terminal,
      restoType
    );
    if (response.data) {
      setUsername("");
      setPassword("");
      setOpenAuthorizeModal(false);
      setOpenDiscountModal(true);
      setHasAuthenticationHistory(true);
      toast.success("Successful Login!", { style: toastStyle() });
    } else {
      setHasAuthenticationHistory(false);
      toast.error(response.error.data.messages.error, {
        style: toastStyle(),
      });
    }
  }

  function validateButton() {
    // here true means disable save button and false otherwise
    if (currentPaymentData.type === "cash") {
      // const result =
      //   totalRemit && totalRemit.trim() !== "" && parseFloat(totalRemit) > 0;
      // return result ? false : true;
      const result = parseFloat(currentPaymentData.paid_amount) > 0;
      return !result;
    } else if (currentPaymentData.type === "card") {
      const result =
        currentPaymentData.approval_no &&
        currentPaymentData.approval_no.trim() !== "" &&
        parseFloat(currentPaymentData.paid_amount) > 0;
      return result ? false : true;
    } else if (currentPaymentData.type === "others") {
      const result =
        currentPaymentData.other_reference_no &&
        currentPaymentData.other_reference_no.trim() !== "" &&
        parseFloat(currentPaymentData.paid_amount) > 0;
      return result ? false : true;
    } else {
      return true;
    }
  }

  const handleApiPrint = (passedRef, printerName, trigger) => {
    if (passedRef.current) {
      const element = passedRef.current;
      html2canvas(element, { scale: 1 }).then(async (canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const blob = new Blob([imgData], { type: "text/plain" });
        const txtFile = new File([blob], "data.txt", { type: "text/plain" });
        // const newWindow = window.open();
        // if (newWindow) {
        //   // Write the image to the new window
        //   newWindow.document.write(`<img src="${imgData}" alt="Captured Image"/>`);
        //   newWindow.document.close();
        // }
        handlePrintTextFile(printerName, txtFile, trigger);
      });
    }
  };

  async function handlePrintTextFile(printerName, textFile, trigger) {
    setPrintingInProgress(true)
    const response = await printAsTextFile(
      printerName,
      textFile,
      trigger,
      restoType
    );
    if (response.data) {
      if (action === "billout") {
        setPrintingInProgress(false)
        // feetchOrder();
      } else {
        setPrintingInProgress(false)
        handleRemoveProduct();
        if (parseFloat(tempChange) > 0) {
          setOpenChangeModal(true);
        } else {
          navigate("/orderingpage");
        }
      }
    }
  }

  async function handleDoneModal() {
    removeOrderId();
    setTimeout(() => {
      navigate("/orderingpage");
      refreshPage();
    }, 500)
  }

  async function handleShowReprintModal() {
    handlePrintSummaryInvoice();
  }

  async function fetchOrder(passedServiceCharge = null) {
    // const response = await getGroupOrderID(orderID);
    const response = await UseGetRequest(
      "orders/show/" + orderID,
      {
        service_charge: passedServiceCharge
          ? passedServiceCharge
          : serviceCharge,
        total_vat_exempt: computedDiscount.total_vat_exempt,
        total_discount: computedDiscount.total_discount,
        for_printing: "1",
      },
      restoType
    );
    if (response.data) {
      const tempOrderDetails = response.data.message.order;
      setPaxCount(parseInt(tempOrderDetails.pax));
      setFoodServer(response.data.message.order.food_server);
      if (
        tempOrderDetails.status === "discounted" ||
        tempOrderDetails.status === "billed"
      ) {
        fetchOrderDiscounts();
      }
      const tempOrderedItems = [];

      let hasStoreOrder = false;
      response.data.message.order_details?.forEach((data) => {
        if (data.pricelist === "store") {
          hasStoreOrder = true;
        }
        if (data.status !== "cancelled") {
          tempOrderedItems.push({ ...data });
        }
      });
      setOrderInfo(tempOrderDetails);
      setOrderItems(tempOrderedItems);
      setSuperGrandTotal(tempOrderDetails.grand_total);
      setCurrentSubtotal(tempOrderDetails.subtotal);
    }
  }

  async function fetchOrderDiscounts() {
    const response = await UseGetRequest(
      "order_discounts/show/" + orderID,
      {},
      restoType
    );
    if (response.data) {
      const discountInfo = response.data;
      setComputedDiscount(discountInfo);
      setServiceCharge(discountInfo.service_charge);
      setSuperGrandTotal(discountInfo.new_total);
      const res = response.data.order_discount_detail?.map((row) => {
        return {...row,
          discount_id: row.discount_id,
          name: row.customer_name,
          id: row.customer_id,
          discount_name: row.discount_type,
        };
      });
      setChosenDiscounts(res);
    }
  }

  async function fetchDiscountTypes() {
    const response = await UseGetRequest("discounts/getAll", {}, restoType);
    if (response.data) {
      var arr = response.data.discounts;
      arr.map((data) => (data.chosen = false));
      setDiscountTypesCopy(arr);
    }
  }

  async function fetchApiDiscountComputation(passedDiscounts) {
    // if (passedDiscounts.length > 0) {
    const payload = {
      requester: getUser(),
      token: getToken(),
      order_id: orderID,
      open_discount_rate:
        passedDiscounts.length > 0
          ? passedDiscounts.map((data) => data.discount_rate ?? null)
          : [],
      open_discount_amount:
        passedDiscounts.length > 0
          ? passedDiscounts.map((data) => data.discount_open_amount ?? null)
          : [],
      discount_ids:
        passedDiscounts.length > 0
          ? passedDiscounts.map((data) => data.discount_id)
          : [],
      customer_names:
        passedDiscounts.length > 0
          ? passedDiscounts.map((data) => data.name)
          : [],
      customer_ids:
        passedDiscounts.length > 0
          ? passedDiscounts.map((data) => data.id)
          : [],
    };

    const response = await UseGetRequest(
      "orders/computeTotalDiscount",
      payload,
      restoType
    );

    if (response.data) {
      setComputedDiscount(response.data.data);
      setServiceCharge(response.data.data.service_charge);
      setSuperGrandTotal(response.data.data.new_total);
      setCurrentPaymentData({...currentPaymentData, paid_amount: 0});
      setTotalRemit(0)
      fetchOrderDiscounts()
    } else {
      setComputedDiscount({});
    }
  }

  async function fetchPaymentDetails(paymentId) {
    const response = await UseGetRequest(
      "payments/show/" + paymentId,
      {},
      restoType
    );
    const paymentResponse = response.data.data;
    const invoiceDiscounts = paymentResponse.data.discount_details;
    const invoicePayments = paymentResponse.data.payment_details;
    setServiceCharge(paymentResponse.data.payment.service_charge);
    setPaymentDetails(paymentResponse.data.payment);
    tempChange = paymentResponse.data.payment.change;
    setPaymentBreakdown(invoicePayments);

    const withEligibleDiscount = invoiceDiscounts.length > 0;
    const withEligiblePayment = invoicePayments.some(
      (item) =>
        item.other_payment_details &&
        (item.other_payment_details.toLowerCase() === "foodpanda" ||
          item.other_payment_details.toLowerCase() === "grab" ||
          item.other_payment_details.toLowerCase() === "charge")
    );

    const print_response = await markOR(paymentId, "print", restoType);

    if (print_response?.data?.message === "Successfully print") {
      toast.success("Marked SI print", {
        style: toastStyle(),
      });
      setTimeout(() => {
        handleApiPrint(printRef, "CASHIER", 1);
      }, 500);
      if (withEligibleDiscount || withEligiblePayment) {
        // handlePrint(reprintRef, "CASHIER", 0);
        setTimeout(() => {
          handleApiPrint(reprintRef, "CASHIER", 0);
        }, 500);
      }
    }
  }

  async function handleBillOut() {
    setIsBillOut(true)
    recordUserActivityLog(`Clicked bill out button`);
    setAction("billout");
    setOrderCart([]);
    callPut(
      "orders/mark_bill_out/" + orderID,
      {
        updated_by: getUser(),
        token: getToken(),
        service_charge: serviceCharge,
      },
      restoType
    );
    setIsBillOut(false)
  }

  function handleResetPayment() {
      recordUserActivityLog(`Clicked reset payments`);
      setTimeout(() => {
        refreshPage();
      }, 500)
  }

  async function handleOpenCashDrawer() {
    const response = await printOpenCashDrawer(window.printer_name);
    if (response.data) {
    } else {
    }
  }

  async function handleLogout() {
    recordUserActivityLog(`Clicked logout button`);
    const response = await logoutUser(restoType);
    if (response.data) {
      toast.success("Logging out...");
      setTimeout(() => {
        removeUserSession();
        navigate("/");
        refreshPage();
      }, 500);
    }
  }

  useEffect(() => {
    if (putResponseData && !isBillOut) {
      const tempSc = putResponseData.message?.service_charge ?? 0;
      setServiceCharge(tempSc);
      fetchOrder(tempSc);
      // if (putResponseData.message.ip_address === "192.168.0.101") {
      //   setTimeout(() => {
      //     handleApiPrint(billoutRef, "rooftop", 0);
      //   }, 2000);
      // } else {
        setTimeout(() => {
          handleApiPrint(billoutRef, "CASHIER", 0);
        }, 2000);
      // }
    }
  }, [putResponseData]);

  useEffect(() => {
    if (noDetails === true) {
      handleDiscountClose("add");
    }
  }, [noDetails]);

  useEffect(() => {
    fetchOrder();
    fetchDiscountTypes();
  }, []);

  useEffect(() => {
    if (responseData) {
      fetchPaymentDetails(responseData.message.payment_id);
    }
  }, [responseData]);

  function getTotalPayment() {
    var isValid = false;
    if (
      currentPaymentData?.type === "cash" &&
      currentPaymentData?.paid_amount &&
      currentPaymentData?.paid_amount !== "" &&
      parseFloat(currentPaymentData.paid_amount) > 0
    ) {
      isValid = true;
    } else if (
      currentPaymentData?.type === "card" &&
      currentPaymentData?.paid_amount &&
      currentPaymentData?.paid_amount !== "" &&
      currentPaymentData?.approval_no &&
      currentPaymentData?.approval_no !== ""
    ) {
      isValid = true;
    } else if (
      currentPaymentData?.type === "others" &&
      currentPaymentData?.paid_amount &&
      currentPaymentData?.paid_amount !== "" &&
      currentPaymentData?.other_reference_no &&
      currentPaymentData?.other_reference_no !== ""
    ) {
      isValid = true;
    }

    if (isValid) {
      const orderGrandTotal = superGrandTotal;
      const tempPayments = !isObjectEmpty(currentPaymentData)
        ? [...multiplePayments, currentPaymentData]
        : multiplePayments;
      const tempTotalPaid = parseFloat(
        tempPayments.reduce(
          (n, { paid_amount }) => n + parseFloat(paid_amount),
          0
        )
      ).toFixed(2);
      // return orderGrandTotal < tempTotalPaid;
      return (
        parseFloat(parseFloat(orderGrandTotal).toFixed(2)) <=
        parseFloat(tempTotalPaid)
      );
    } else {
      return false;
    }
  }

  function getRealTimeChange() {
    const combinedPayment = !isObjectEmpty(currentPaymentData)
      ? [...multiplePayments, currentPaymentData]
      : multiplePayments;
    const tempPayments = combinedPayment.filter(
      (item) => item.paid_amount && item.paid_amount !== ""
    );
    const tempTotalPaid =
      tempPayments.length > 0
        ? parseFloat(
            tempPayments.reduce(
              (n, { paid_amount }) => n + parseFloat(paid_amount),
              0
            )
          )
        : 0;
    // const orderGrandTotal = parseFloat(
    //   note === "no discount"
    //     ? parseFloat(grandTotal)+parseFloat(serviceCharge) + parseFloat(tax)
    //     : computedDiscount?.new_total
    //     ? computedDiscount.new_total + parseFloat(tax)
    //     : parseFloat(grandTotal)+parseFloat(serviceCharge) + parseFloat(tax)
    // ).toFixed(2);
    const orderGrandTotal = superGrandTotal;

    // return parseFloat(orderGrandTotal-tempTotalPaid).toFixed(2);
    if (parseFloat(tempTotalPaid - orderGrandTotal) > 0) {
      return parseFloat(tempTotalPaid - orderGrandTotal).toFixed(2);
    } else {
      return 0.0;
      // return parseFloat(orderGrandTotal-tempTotalPaid);
    }
  }

  React.useEffect(() => {
    async function fetchAllUsers() {
      const response = await UseGetRequest("users/search", {}, getRestoLogin());
      if (response.data) {
        const res = response.data.map((row) => {
          return {
            value: row.username,
            label: row.username,
          };
        });
        setUserOptions(res);
      } else {
        setUserOptions([]);
      }
    }

    fetchAllUsers();
  }, []);

  React.useEffect(() => {
    getTotalPayment();
    getRealTimeChange();
  }, [currentPaymentData]);

  React.useEffect(() => {
    const tempBal =
      parseFloat(superGrandTotal).toFixed(2) -
      parseFloat(totalPayment).toFixed(2);
    setRemainingBalance(tempBal);
    // setCurrentPaymentData({...currentPaymentData, paid_amount: parseFloat(tempBal).toFixed(2)});
    setCurrentPaymentData({ ...currentPaymentData, paid_amount: 0 });
  }, [superGrandTotal, totalPayment]);

  /*
Notes on Discount: [discount ID: discount name]
  1 - Senior Citizen
  2 - PWD
  3 - Zero-rated
  4 - Employee
  5 - max senior/pwd
  7 - OPEN DISCOUNT AMOUNT
  8 - OPEN DISCOUNT RATE
*/
  /*
wrong sequence
1. OPEN RATE / OPEN AMOUNT DISC
2. PWD / SENIOR

mao ni ang correct sequence dapat
1. PWD / SENIOR
2. OPEN RATE / OPEN AMOUNT DISC / EMPLOYEE
3. DLI NA MAKA ADD HER
*/

  React.useEffect(() => {
    if (chosenDiscounts.length === 0) {
      setDisabledDiscounts([]);
    } else {
      const isZeroRatedSelected = chosenDiscounts.some(
        (disc) => disc.discount_id === "3"
      ); // if zer-rated is selected
      const isSeniorPwdSelected = chosenDiscounts.some(
        (disc) =>
          disc.discount_id === "1" ||
          disc.discount_id === "2" ||
          disc.discount_id === "5"
      ); // if senior OR pwd is added
      const isOthersSelected = chosenDiscounts.some(
        (disc) =>
          disc.discount_id === "8" ||
          disc.discount_id === "7" ||
          disc.discount_id === "4"
      ); // if open rate, open disc amount, OR employee selected

      if ((isSeniorPwdSelected && isOthersSelected) || isZeroRatedSelected) {
        // if either senior OR pwd already selected AND either open rate, open disc, OR employee selected
        setDisabledDiscounts(["1", "2", "3", "4", "5", "7", "8"]); //  can no longer add na
      } else if (!isSeniorPwdSelected && isOthersSelected) {
        setDisabledDiscounts(["1", "2", "3", "5", "4", "7", "8"]);
      } else if (isSeniorPwdSelected && !isOthersSelected) {
        setDisabledDiscounts(["3"]);
        // chosenDiscounts.forEach((row, index) => {
        //   setDisabledDiscounts(["3"])
        // })
      }
    }
  }, [chosenDiscounts]);

  return (
    <div className="visible-overflow">
      <div
        className={`container bold-font ${
          userRole === "2" ||
          userRole === "1" ||
          userRole === "7" ||
          userRole === "8"
            ? "cashier"
            : inactive
            ? "inactive"
            : "active"
        } visible-overflow`}
        id="forPrinting"
      >
        <Row className="">
          <Col xs={5}>
            <h3 style={{ color: "var(--title-color)" }} className="redo-title">
              ADD PAYMENT
            </h3>
          </Col>
          <Col xs={7}>
            <Row>
              <Col>
                <h3
                  style={{ color: "var(--title-color)" }}
                  className="redo-title"
                >
                  PAYMENT
                </h3>
              </Col>
              <Col className="d-flex justify-content-end">
                <Button
                  variant="danger"
                  className="mb-2"
                  onClick={handleResetPayment}
                >
                  RESET PAYMENTS
                </Button>
              </Col>
            </Row>
          </Col>
          <hr />
        </Row>
        {/* <Row className="b-shadow count-border rounded "> */}
        <Row className="payment-window">
          <Col>
            <Row>
              <Col
                xl={5}
                lg={5}
                md={5}
                sm={5}
                xs={5}
                className="p-3 left-side-payment"
              >
                <Row className="mt-1">
                  <Col xs={6}>
                    <h5 className="left-text ">SUBTOTAL </h5>
                  </Col>
                  <Col xs={6}>
                    <h5 className="left-text align-right">
                      ₱ {numberFormat(orderInfo.subtotal)}
                    </h5>
                  </Col>
                </Row>
                {chosenDiscounts && chosenDiscounts.length > 0 && (
                  <>
                    <Row>
                      <h5 className="left-text ms-2">DISCOUNT DETAILS</h5>
                    </Row>
                    <Row className="ms-1 d-flex justify-content-between discount-details mb-2">
                      <Col xs={4}>
                        <label className="left-text-sub">TYPE</label>
                      </Col>
                      <Col xs={3}>
                        <label className="left-text-sub">ID</label>
                      </Col>
                      <Col xs={3}>
                        <label className="left-text-sub">NAME</label>
                      </Col>
                      <Col xs={2}></Col>
                    </Row>
                  </>
                )}
                {chosenDiscounts?.map((data, index) => {
                  return (
                    <>
                      <Row className="ms-1 d-flex justify-content-between white-text discount-details">
                        <Col xs={4}>{data.discount_name}</Col>
                        <Col xs={3}>{data.id}</Col>
                        <Col xs={3}>{data.name}</Col>
                        <Col xs={2} className="text-center">
                          <MinusCircleFilled
                            onClick={() => deleteDiscount(index)}
                          />
                        </Col>
                      </Row>
                      <hr className="discount-details-hr" />
                    </>
                  );
                })}
                <Row className="d-flex row justify-content-between mt-2">
                  <Col xs={6}>
                    <h5 className="left-text">DISCOUNT</h5>
                  </Col>
                  <Col xs={6}>
                    <h5 className="left-text align-right">
                      ₱ &nbsp;
                      {numberWithCommas(computedDiscount.total_discount)}
                    </h5>
                  </Col>
                </Row>
                <Row className="d-flex row justify-content-between mb-3">
                  <Col xs={6}>
                    <h5 className="left-text">VAT EXEMPTION</h5>
                  </Col>
                  <Col xs={6}>
                    <h5 className="left-text align-right">
                      ₱ &nbsp;
                      {/* {numberFormat(
                        parseFloat(
                          note === "no discount"
                            ? 0.0
                            : computedDiscount.total_vat_exempt
                        ).toFixed(2)
                      )} */}
                      {numberFormat(computedDiscount.total_vat_exempt)}
                    </h5>
                  </Col>
                </Row>
                <Row className="d-flex row justify-content-between mb-3">
                  <Col xs={6}>
                    <h5 className="left-text">SERVICE CHARGE</h5>
                  </Col>
                  <Col xs={6}>
                    <h5 className="left-text align-right">
                      ₱ &nbsp;
                      {numberFormat(serviceCharge)}
                    </h5>
                  </Col>
                </Row>

                <hr className="p-0 m-0 mb-3 mt-3" />
                <Row className="d-flex row justify-content-between mb-3">
                  <Col xs={6}>
                    <h5 className="left-text-total">
                      <>GRAND TOTAL</>
                    </h5>
                  </Col>
                  <Col xs={6}>
                    <h5 className="left-text-total align-right">
                      <>
                        ₱ {numberWithCommas(superGrandTotal)}
                        {/* {numberWithCommas(
                          parseFloat(
                            note === "no discount"
                              ? parseFloat(grandTotal)+parseFloat(serviceCharge) + parseFloat(tax)
                              : computedDiscount?.new_total
                              ? computedDiscount.new_total + parseFloat(tax)
                              : parseFloat(grandTotal)+parseFloat(serviceCharge) + parseFloat(tax)
                          ).toFixed(2)
                        )} */}
                      </>
                    </h5>
                  </Col>
                  <Col xs={2}></Col>
                </Row>
                <Row className="mt-1">
                  <Col xs={6}>
                    <h5 className="left-text ">TOTAL PAYMENT </h5>
                  </Col>
                  <Col xs={6}>
                    <h5 className="left-text align-right">
                      ₱ {numberFormat(totalPayment)}
                    </h5>
                  </Col>
                </Row>
                <Row className="d-flex row justify-content-between mb-3">
                  <Col xs={6}>
                    <h5 className="left-text">
                      <>BALANCE</>
                    </h5>
                  </Col>
                  <Col xs={6}>
                    <h5 className="left-text-total align-right">
                      <>
                        ₱{" "}
                        {numberWithCommas(
                          remainingBalance >= 0 ? remainingBalance : "0.00"
                        )}
                      </>
                    </h5>
                  </Col>
                  <Col xs={2}></Col>
                </Row>
              </Col>
              <Col className="p-3 left-div-payment">
                <Row>
                  <Row>
                    <Col sm={4} className="payment-width">
                      <div>
                        <button
                          class={
                            details.type === "cash"
                              ? "payment-button-click"
                              : "payment-button clr-white"
                          }
                          value="Cash"
                          onClick={handlePaymentSource}
                        >
                          CASH
                        </button>
                      </div>
                    </Col>
                    <Col sm={4} className="payment-width">
                      <div>
                        <button
                          class={
                            details.type === "card"
                              ? "payment-button-click"
                              : "payment-button clr-white"
                          }
                          value="Card"
                          onClick={handlePaymentSource}
                        >
                          CARD
                        </button>
                      </div>
                    </Col>

                    <Col sm={4} className="payment-width">
                      <div>
                        <button
                          class={
                            details.type === "others"
                              ? "payment-button-click"
                              : "payment-button clr-white"
                          }
                          value="Others"
                          onClick={handlePaymentSource}
                        >
                          OTHERS
                        </button>
                      </div>
                    </Col>
                  </Row>
                  <hr className="p-0 m-0 mb-3 mt-3" />
                </Row>

                {openCashDetails && (
                  <div>
                    <Row className="d-flex row justify-content-center"></Row>
                    <Row className="mb-1">
                      <Col xs={3} className="">
                        <label className="right-text">TOTAL CASH</label>
                      </Col>
                      <Col xs={7} className="">
                        <Form.Control
                          size="md"
                          type="number"
                          class="form-control"
                          value={totalRemit > 0 ? totalRemit : ""}
                          onChange={(e) => {
                            setTotalRemit(e.target.value);
                            setCurrentPaymentData((prev) => ({
                              ...prev,
                              paid_amount: e.target.value,
                            }));
                          }}
                        />
                      </Col>
                    </Row>
                    <Row className="mt-2">
                      <Col xs={3} className="pt-1">
                        <h5 className="right-text">CHANGE</h5>
                      </Col>
                      <Col xs={7}>
                        <Form.Control
                          size="md"
                          type="text"
                          class="form-control"
                          value={getRealTimeChange()}
                          disabled
                        />
                      </Col>
                    </Row>
                  </div>
                )}
                {openCard && (
                  <div className="p-1">
                    <Row
                      className="row mb-1"
                      style={{ overflow: "scroll !important" }}
                    >
                      <Col xs={4} className="pt-0">
                        <label className="right-text">APPROVAL NO.</label>
                      </Col>
                      <Col xs={7}>
                        <Form.Control
                          size="md"
                          type=""
                          name="card_no"
                          className="form-control"
                          onChange={(e) => {
                            setDetails((prev) => ({
                              ...prev,
                              card_no: e.target.value,
                            }));
                            setCurrentPaymentData((prev) => ({
                              ...prev,
                              approval_no: e.target.value,
                            }));
                          }}
                        />
                      </Col>
                    </Row>
                    <Row className="mt-2">
                      <Col xs={4} className="pt-2">
                        <label className="right-text">CARD AMOUNT</label>
                      </Col>
                      <Col xs={7}>
                        <Form.Control
                          size="md"
                          type="text"
                          name="card_amount"
                          onChange={(e) => {
                            setDetails((prev) => ({
                              ...prev,
                              card_no: e.target.value,
                            }));
                            setCurrentPaymentData((prev) => ({
                              ...prev,
                              paid_amount: e.target.value,
                            }));
                          }}
                          class="form-control"
                          aria-label="Small"
                          aria-describedby="inputGroup-sizing-sm"
                          value={currentPaymentData.paid_amount}
                          // value={remainingBalance}
                        />
                      </Col>
                    </Row>
                    <Row className="d-flex row justify-content-between mt-2">
                      <Col xs={4} className="pt-2">
                        <label className="right-text">CARD TYPE</label>
                      </Col>
                      <Col>
                        <Row>
                          <Col className="p-1 grid">
                            <Button
                              size="sm"
                              className={`other-payment-options ${
                                details["card_type"] === "debit"
                                  ? "active b-shadow"
                                  : ""
                              } `}
                              value="debit"
                              onClick={(e) => {
                                recordUserActivityLog(`Clicked DEBIT card type`);
                                setDetails((prev) => ({
                                  ...prev,
                                  card_type: "debit",
                                }));
                                setCurrentPaymentData((prev) => ({
                                  ...prev,
                                  card_type: "debit",
                                }));
                              }}
                            >
                              DEBIT
                            </Button>
                            <Button
                              size="sm"
                              className={`other-payment-options ${
                                details["card_type"] === "credit"
                                  ? "active b-shadow"
                                  : ""
                              } `}
                              value="credit"
                              onClick={(e) => {
                                recordUserActivityLog(`Clicked CREDIT card type`);
                                setDetails((prev) => ({
                                  ...prev,
                                  card_type: "credit",
                                }));
                                setCurrentPaymentData((prev) => ({
                                  ...prev,
                                  card_type: "credit",
                                }));
                              }}
                            >
                              CREDIT
                            </Button>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </div>
                )}

                {openOthers && (
                  <div className=" p-1 purchases-div">
                    <Row className="row mb-1">
                      <Col xs={5} className="pt-0">
                        <label className="right-text">REFERENCE NO/NAME</label>
                      </Col>
                      <Col xs={7}>
                        <Form.Control
                          size="md"
                          type="text"
                          name="other_reference_no"
                          onChange={(e) => {
                            setDetails((prev) => ({
                              ...prev,
                              other_reference_no: e.target.value,
                            }));
                            setCurrentPaymentData((prev) => ({
                              ...prev,
                              other_reference_no: e.target.value,
                            }));
                          }}
                          class="form-control"
                          aria-label="Small"
                          aria-describedby="inputGroup-sizing-sm"
                          value={currentPaymentData.other_reference_no}
                        />
                      </Col>
                    </Row>
                    <Row className="row mt-2">
                      <Col xs={5} className="pt-1">
                        <label className="right-text">AMOUNT</label>
                      </Col>
                      <Col xs={7}>
                        <Form.Control
                          size="md"
                          type="text"
                          name="other_amount"
                          onChange={(e) => {
                            setDetails((prev) => ({
                              ...prev,
                              other_amount: e.target.value,
                            }));
                            setCurrentPaymentData((prev) => ({
                              ...prev,
                              paid_amount: e.target.value,
                            }));
                          }}
                          class="form-control"
                          aria-label="Small"
                          aria-describedby="inputGroup-sizing-sm"
                          value={currentPaymentData.paid_amount}
                          // value={remainingBalance}
                        />
                      </Col>
                    </Row>
                    <Row className="d-flex row justify-content-between mt-2">
                      <Col xs={5} className="pt-2">
                        <label className="right-text">PAYMENT SOURCE</label>
                      </Col>
                      <Col>
                        <Row className="">
                          <Col xs={3} className="other-source-col">
                            <Button
                              name="other_source"
                              className={`other-payment-options w-100 mb-0 ${
                                details["other_source"] === "Gcash"
                                  ? "active b-shadow"
                                  : ""
                              } `}
                              value="Gcash"
                              onClick={(e) => {
                                recordUserActivityLog(`Clicked GCASH payment source`);
                                setDetails((prev) => ({
                                  ...prev,
                                  other_source: "Gcash",
                                }));
                                setCurrentPaymentData((prev) => ({
                                  ...prev,
                                  other_source: "Gcash",
                                }));
                              }}
                            >
                              GCASH
                            </Button>
                          </Col>
                          <Col xs={3} className="other-source-col">
                            <Button
                              name="other_source"
                              className={`other-payment-options w-100 ${
                                details["other_source"] === "Maya"
                                  ? "active b-shadow"
                                  : ""
                              } `}
                              value="Maya"
                              onClick={(e) => {
                                recordUserActivityLog(`Clicked MAYA payment source`);
                                setDetails((prev) => ({
                                  ...prev,
                                  other_source: "Maya",
                                }));
                                setCurrentPaymentData((prev) => ({
                                  ...prev,
                                  other_source: "Maya",
                                }));
                              }}
                            >
                              MAYA
                            </Button>
                          </Col>
                          <Col xs={3} className="other-source-col">
                            <Button
                              name="other_source"
                              className={`other-payment-options w-100 ${
                                details["other_source"] === "Grab"
                                  ? "active b-shadow"
                                  : ""
                              } `}
                              value="Grab"
                              onClick={(e) => {
                                recordUserActivityLog(`Clicked GRAB payment source`);
                                setDetails((prev) => ({
                                  ...prev,
                                  other_source: "Grab",
                                }));
                                setCurrentPaymentData((prev) => ({
                                  ...prev,
                                  other_source: "Grab",
                                }));
                              }}
                            >
                              GRAB
                            </Button>
                          </Col>
                          <Col xs={3} className="other-source-col">
                            <Button
                              name="other_source"
                              className={`other-payment-options w-100 ${
                                details["other_source"] === "charge"
                                  ? "active b-shadow"
                                  : ""
                              } `}
                              value="charge"
                              onClick={(e) => {
                                recordUserActivityLog(`Clicked CHARGE payment source`);
                                setDetails((prev) => ({
                                  ...prev,
                                  other_source: "charge",
                                }));
                                setCurrentPaymentData((prev) => ({
                                  ...prev,
                                  other_source: "charge",
                                }));
                              }}
                            >
                              Charge
                            </Button>
                          </Col>
                          <Col xs={5} className="other-source-col">
                            <Button
                              name="other_source"
                              className={`other-payment-options w-100 ${
                                details["other_source"] === "Foodpanda"
                                  ? "active b-shadow"
                                  : ""
                              } `}
                              value="Foodpanda"
                              onClick={(e) => {
                                recordUserActivityLog(`Clicked FOODPANDA payment source`);
                                setDetails((prev) => ({
                                  ...prev,
                                  other_source: "Foodpanda",
                                }));
                                setCurrentPaymentData((prev) => ({
                                  ...prev,
                                  other_source: "Foodpanda",
                                }));
                              }}
                            >
                              FOODPANDA
                            </Button>
                          </Col>
                          <Col xs={5} className="other-source-col">
                            <Button
                              name="other_source"
                              className={`other-payment-options w-100 ${
                                details["other_source"] === "coupon"
                                  ? "active b-shadow"
                                  : ""
                              } `}
                              value="coupon"
                              onClick={(e) => {
                                recordUserActivityLog(`Clicked GC/CUOPON payment source`);
                                setDetails((prev) => ({
                                  ...prev,
                                  other_source: "coupon",
                                }));
                                setCurrentPaymentData((prev) => ({
                                  ...prev,
                                  other_source: "coupon",
                                }));
                              }}
                            >
                              GC/Coupon
                            </Button>
                          </Col>

                          {/* </Col> */}
                        </Row>
                      </Col>
                    </Row>
                  </div>
                )}

              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="mt-2 "></Row>
        <Row className="d-flex justify-content-center mb-1 mt-3">
          <Col sm={12}>
            <Row>
              <Col sm={3} className="p-1 align-center">
                <Button
                  size="lg"
                  variant="warning"
                  style={{ width: "100%" }}
                  value={remainingBalance}
                  onClick={(e) => exactAmount(e)}
                  disabled={userRole === "8"}
                >
                  EXACT AMOUNT
                </Button>
              </Col>
              <Col sm={2} className="p-1 align-center">
                {userRole !== "1" && !hasAuthenticationHistory ? (
                  <Button
                    size="lg"
                    variant="warning"
                    style={{ width: "100%", cursor: "pointer" }}
                    onClick={() => {
                      recordUserActivityLog(`Clicked discount authorization modal`); 
                      setOpenAuthorizeModal(true)
                    }}
                    disabled={chosenDiscounts.length > 0 && paxCount === 1}
                  >
                    DISCOUNT
                  </Button>
                ) : (
                  <Button
                    size="lg"
                    variant="warning"
                    style={{ width: "100%", cursor: "pointer" }}
                    onClick={() => {
                      recordUserActivityLog(`Clicked open discount modal`); 
                      setOpenDiscountModal(true)}
                    }
                    disabled={chosenDiscounts.length >= paxCount}
                  >
                    DISCOUNT
                  </Button>
                )}
              </Col>
              <Col sm={2} className="p-1 align-right">
                <Button
                  size="lg"
                  variant="warning"
                  style={{ width: "100%" }}
                  onClick={handleBillOut}
                >
                  BILL OUT
                </Button>
              </Col>
              <>
                <Col sm={3} className="p-1 align-right">
                  <Button
                    disabled={
                      validateButton() ||
                      disableClick ||
                      userRole === "8" ||
                      getTotalPayment()
                    }
                    size="lg"
                    variant="warning"
                    style={{ width: "100%" }}
                    onClick={handleAddPayment}
                  >
                    SAVE PAYMENT
                  </Button>
                </Col>
                <Col sm={2} className="p-1 align-right">
                  <Badge.Ribbon
                    className="settlement-badge"
                    text={
                      orderInfo.status === "billed"
                        ? "BILLED OUT"
                        : "NO BILL OUT"
                    }
                    color={orderInfo.status === "billed" ? "green" : "red"}
                    placement="start"
                  >
                    <Button
                      disabled={
                        // (validateButton() && !getTotalPayment()) ||
                        // validateButton() || !getTotalPayment() ||
                        !getTotalPayment() ||
                        disableClick ||
                        orderInfo.status !== "billed" ||
                        isLoading ||
                        userRole === "8"
                      }
                      size="lg"
                      variant="warning"
                      style={{ width: "100%" }}
                      onClick={() => {
                        setAction("settle");
                        if (orderInfo.status === "pending") {
                          confirmPayment();
                        } else {
                          submitPayment();
                        }
                      }}
                    >
                      SETTLE
                    </Button>
                  </Badge.Ribbon>
                </Col>
              </>
            </Row>
          </Col>
        </Row>
      </div>
      <Row className="payment-ordering-navbar">
        <Col className="d-flex justify-content-center ant-col">
          <WidgetsIcon className="footer-icon-disabled" />
        </Col>
        <Col className="d-flex justify-content-center ant-col">
          <HomeIcon
            className="footer-icon"
            onClick={(e) => {
              handleTableActivation(localFetchSelectedTable, "active")
              recordUserActivityLog(`Clicked home icon navigation`);
              setTimeout(() => {
                navigate("/orderingpage");
                refreshPage();
              }, 500)
            }}
          />
        </Col>
        <Col className="d-flex justify-content-center ant-col">
          <PaidIcon className="footer-icon-disabled" />
        </Col>
        <Col className="d-flex justify-content-center ant-col">
          <PointOfSaleIcon
            className={
              userRole === "1" ? "footer-icon" : "footer-icon-disabled"
            }
            onClick={() => {
              if (userRole === "1") {
                recordUserActivityLog(`Clicked open cash drawer`);
                handleOpenCashDrawer();
              }
            }}
          />
        </Col>
        <Col className="d-flex justify-content-center">
          <LogoutOutlined
            className="footer-icon"
            onClick={() => {
              handleRemoveActiveAttending();
              handleLogout();
            }}
          />
        </Col>
      </Row>

      {/* PRINT OUT CONTENTS */}
      <div 
        className="hide-from-screen"
      >
        <div ref={printRef}>
          <div className="d-flex justify-content-center">
            <CommonPrint
              type="officialReceipt"
              discounts={chosenDiscounts}
              orderItems={orderItems}
              orderInfo={orderInfo}
              paymentDetails={paymentDetails}
              paymentBreakdown={paymentBreakdown}
              computedDiscount={computedDiscount}
              serviceCharge={serviceCharge}
              superGrandTotal={superGrandTotal}
              foodServer={foodServer}
            />
          </div>
        </div>

        <div ref={reprintRef}>
          <div className="d-flex justify-content-center">
            <CommonPrint
              isReprint
              type="officialReceipt"
              discounts={chosenDiscounts}
              orderItems={orderItems}
              orderInfo={orderInfo}
              paymentDetails={paymentDetails}
              paymentBreakdown={paymentBreakdown}
              computedDiscount={computedDiscount}
              serviceCharge={serviceCharge}
              superGrandTotal={superGrandTotal}
              foodServer={foodServer}
            />
          </div>
        </div>

        <div
          ref={billoutRef}
        >
          <div className="d-flex justify-content-center">
            <CommonPrint
              type="billout"
              discounts={chosenDiscounts}
              orderItems={orderItems}
              orderInfo={orderInfo}
              paymentDetails={paymentDetails}
              computedDiscount={computedDiscount}
              serviceCharge={serviceCharge}
              superGrandTotal={superGrandTotal}
              foodServer={foodServer}
            />
          </div>
        </div>
      </div>

      {/* DISCOUNT OPTIONS MODAL */}
      <Modal
        size="lg"
        show={openDiscountModal}
        onHide={() => setOpenDiscountModal(false)}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Body className="bold-font py-4 px-5">
          <h5>CHOOSE DISCOUNT</h5>
          <hr />
          <Row className="overflow-hidden">
            {discountTypesCopy.map((data) => {
              return (
                <Col xs={12} md={4} className="mt-2">
                  <Button
                    className="discount-option"
                    onClick={() => handleDiscountClick(data)}
                    disabled={disabledDicounts.includes(data.id)}
                  >
                    {data.name?.toUpperCase()}
                  </Button>
                </Col>
              );
            })}
          </Row>
          <hr />
          <Row className="mt-4">
            <Col className="d-flex justify-content-end">
              <Button
                className="cancel-btn"
                onClick={() => {recordUserActivityLog(`Clicked cancel choose discount modal`); setOpenDiscountModal(false)}}
              >
                CANCEL
              </Button>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      {/* Modal for Open Discount Amount */}
      <Modal
        size="md"
        show={isOpenPrice}
        onHide={() => setIsOpenPrice(false)}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Body className="bold-font p-3">
          <h4>OPEN DISCOUNT AMOUNT</h4>
          <AntForm
            layout="vertical"
            form={discountForm}
            onFinish={(e) => {
              discountForm.resetFields();
              handleDiscountClose("add");
            }}
          >
            <hr />
            <Row className="mt-3">
              <Col xs={12}>
                <AntForm.Item
                  label="AMOUNT"
                  name="amount"
                  rules={[
                    {
                      required: currentDiscount.discount_id === "4",
                      message: "Please enter name",
                    },
                  ]}
                >
                  <Input
                    type="number"
                    onChange={(e) => {
                      setOpenPriceAmount(e.target.value);
                      setCurrentDiscount({
                        ...currentDiscount,
                        discount_open_amount: e.target.value,
                      });
                    }}
                    onWheel={(e) => e.target.blur()}
                  />
                </AntForm.Item>
              </Col>
              <Col xs={12}>
                <AntForm.Item
                  label="ID"
                  name="id"
                  rules={[{ required: false, message: "Please enter ID" }]}
                >
                  <Input
                    onChange={(e) => {
                      setCurrentDiscount({
                        ...currentDiscount,
                        id: e.target.value,
                      });
                    }}
                  />
                </AntForm.Item>
              </Col>
              <Col xs={12}>
                <AntForm.Item
                  label="MEMO"
                  name="name"
                  rules={[{ required: true, message: "Please enter memo" }]}
                >
                  <Input
                    onChange={(e) => {
                      setCurrentDiscount({
                        ...currentDiscount,
                        name: e.target.value,
                      });
                    }}
                  />
                </AntForm.Item>
              </Col>

              <AntForm.Item>
                <AntRow className="d-flex justify-content-end mt-3">
                  <AntRow>
                    <AntButton
                      className="me-2"
                      danger
                      onClick={() => {
                        handleOpenDiscountClose("amount");
                        discountForm.resetFields();
                      }}
                    >
                      Cancel
                    </AntButton>
                    <AddSubmitButton
                      form={discountForm}
                      isLoading={isLoading}
                      buttonText="Add"
                    />
                  </AntRow>
                </AntRow>
              </AntForm.Item>
            </Row>
          </AntForm>

        </Modal.Body>
      </Modal>

      {/* Modal for Open Rate Discount */}
      <Modal
        size="md"
        show={openRate}
        onHide={() => setOpenRate(false)}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Body className="bold-font p-3">
          <h5>OPEN DISCOUNT RATE</h5>
          <hr />
          <AntForm
            layout="vertical"
            form={discountForm}
            onFinish={(e) => {
              discountForm.resetFields();
              handleDiscountClose("add");
            }}
          >
            <Row>
              <Col xs={12}>
                <AntForm.Item
                  label="PERCENTAGE"
                  name="percentage"
                  rules={[{ required: true, message: "Please enter name" }]}
                >
                  <Input
                    type="number"
                    onChange={(e) => {
                      setOpenRatePercentage(e.target.value);
                      setCurrentDiscount({
                        ...currentDiscount,
                        discount_rate: e.target.value,
                      });
                    }}
                    onWheel={(e) => e.target.blur()}
                  />
                </AntForm.Item>
              </Col>
              <Col xs={12}>
                <AntForm.Item
                  label="ID"
                  name="id"
                  rules={[{ required: false, message: "Please enter ID" }]}
                >
                  <Input
                    onChange={(e) => {
                      setCurrentDiscount({
                        ...currentDiscount,
                        id: e.target.value,
                      });
                    }}
                  />
                </AntForm.Item>
              </Col>
              <Col xs={12}>
                <AntForm.Item
                  label="MEMO"
                  name="name"
                  rules={[{ required: true, message: "Please enter memo" }]}
                >
                  <Input
                    onChange={(e) => {
                      setCurrentDiscount({
                        ...currentDiscount,
                        name: e.target.value,
                      });
                    }}
                  />
                </AntForm.Item>
              </Col>
              <AntForm.Item>
                <AntRow className="d-flex justify-content-end mt-4">
                  <AntRow>
                    <AntButton
                      className="me-2"
                      danger
                      onClick={() => {
                        handleOpenDiscountClose("rate");
                        discountForm.resetFields();
                      }}
                    >
                      Cancel
                    </AntButton>
                    <AddSubmitButton
                      form={discountForm}
                      isLoading={isLoading}
                      buttonText="Add"
                    />
                  </AntRow>
                </AntRow>
              </AntForm.Item>
            </Row>
          </AntForm>
        </Modal.Body>
      </Modal>

      {/* ADD DISCOUNT AUTHENTICATION */}
      <AntModal
        open={openAuthorizeModal}
        onCancel={() => setOpenAuthorizeModal(false)}
        footer={null}
        title="AUTHENTICATE"
      >
        <AntRow className="mt-3">
          <div className="custom-select-container w-100">
            <UserOutlined className="custom-select-icon black" />
            <Select
              suffixIcon={null}
              placeholder="Username"
              options={userOptions}
              showSearch
              filterOption={(input, option) =>
                option.label?.toLowerCase().includes(input?.toLowerCase())
              }
              onChange={(e) => setUsername(e)}
            />
          </div>
        </AntRow>
        <AntRow className="mt-2">
          <Input.Password
            className="bigger-input-field"
            prefix={<LockOutlined className="site-form-item-icon" />}
            type="password"
            placeholder="Password"
            onChange={(e) => setPassword(e.target.value)}
            onKeyPress={(e) =>
              e.key === ("Enter" || "NumpadEnter") &&
              handleLoginAuthentication()
            }
          />
        </AntRow>
        <AntRow className="mt-3 d-flex justify-content-end">
          <Space>
            <AntButton
              className="me-2 px-4 bigger-btn"
              onClick={() => {
                setOpenAuthorizeModal(false);
              }}
            >
              Cancel
            </AntButton>
            <AntButton
              type="primary"
              className="px-4 bigger-btn"
              onClick={handleLoginAuthentication}
              disabled={username === "" || password === ""}
            >
              Submit
            </AntButton>
          </Space>
        </AntRow>
      </AntModal>

      {/* DISCOUNT DETAILS MODAL */}
      <Modal
        size="md"
        show={openDiscountDetails}
        onHide={() => setOpenDiscountDetails(false)}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Body className="bold-font">
          <h5>ENTER DETAILS</h5>
          <hr />
          <AntForm
            layout="vertical"
            form={discountForm}
            onFinish={(e) => {
              recordUserActivityLog(`Clicked save discount details`);
              if (
                currentDiscount.discount_rate === "0" &&
                currentDiscount.discount_open_amount === "0"
              ) {
                handleDiscountClose("add");
              } else if (currentDiscount.discount_rate === "1") {
                setOpenRate(true);
              } else if (currentDiscount.discount_open_amount) {
                setIsOpenPrice(true);
              }
              discountForm.resetFields();
            }}
          >
            <Row>
              <Col xs={12}>
                <AntForm.Item
                  label="Name"
                  name="name"
                  rules={[
                    {
                      required: currentDiscount.discount_id === "4",
                      message: "Please enter name",
                    },
                  ]}
                >
                  <Input
                    onChange={(e) => {
                      setCurrentDiscount({
                        ...currentDiscount,
                        name: e.target.value,
                      });
                    }}
                  />
                </AntForm.Item>
              </Col>
              <Col xs={12}>
                <AntForm.Item
                  label="ID"
                  name="id"
                  rules={[{ required: false, message: "Please enter ID" }]}
                >
                  <Input
                    onChange={(e) => {
                      setCurrentDiscount({
                        ...currentDiscount,
                        id: e.target.value,
                      });
                    }}
                  />
                </AntForm.Item>
              </Col>
              <AntForm.Item>
                <AntRow className="d-flex justify-content-end mt-4">
                  <AntRow>
                    <AntButton
                      className="me-2"
                      danger
                      onClick={() => {
                        recordUserActivityLog(`Clicked cancel on discount enter details`);
                        discountForm.resetFields();
                        handleOpenDiscountClose("");
                      }}
                    >
                      Cancel
                    </AntButton>
                    <AddSubmitButton
                      form={discountForm}
                      isLoading={isLoading}
                      buttonText="Add"
                    />
                  </AntRow>
                </AntRow>
              </AntForm.Item>
            </Row>
          </AntForm>
        </Modal.Body>
      </Modal>

      <Modal
        size="sm"
        show={doneModal}
        onHide={() => setDoneModal(false)}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header className="bold-font"> </Modal.Header>
        <Modal.Body className="bold-font">
          <Row>
            <Col xs={12} className="">
              <Form.Label htmlFor="inputPassword5" require>
                Do you want to print again?
              </Form.Label>
            </Col>
          </Row>
          <Row className="align-right">
            <Col>
              <Row style={{ textAlignLast: "center" }} className="mt-5">
                <Col sm={4}></Col>
                <Col sm={4} className="mb-3">
                  <Button
                    size="sm"
                    style={{ width: "100%" }}
                    onClick={() => handleShowReprintModal()}
                  >
                    YES
                  </Button>
                </Col>
                <Col sm={4}>
                  <Button
                    size="sm"
                    style={{ width: "100%" }}
                    onClick={() => handleDoneModal()}
                  >
                    NO
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      {/* MODAL TO DISPLAY CHANGE */}
      <Modal
        size="lg"
        show={openChangeModal}
        onHide={() => setOpenChangeModal(false)}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header className="bold-font"> </Modal.Header>
        <Modal.Body className="bold-font">
          <Row>
            <Row>
              <Col className="text-center mt-5">
                <h1 className="subtitle">
                  CHANGE: ₱&nbsp;{formatAmount(paymentDetails.change)}
                </h1>
              </Col>
            </Row>
            <Col>
              <Row style={{ textAlignLast: "center" }} className="mt-5">
                <Col sm={6}></Col>
                <Col sm={6} className="align-right">
                  <Button
                    size="lg"
                    className="save-btn"
                    style={{
                      width: "70%",
                      paddingTop: "10px",
                      paddingBottom: "10px",
                    }}
                    onClick={() => navigate("/orderingpage")}
                  >
                    DONE
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      <AntModal
        maskClosable={false}
        open={printingInProgress}
        footer={null}
        closeIcon={false}
      >
        <AntRow className="d-flex justify-content-center">
          <Title level={5}>PRINTING IN PROGRESS</Title>
        </AntRow>
        <Row className="d-flex justify-content-center mt-3">
          <Spin size="large"/>
        </Row>
        <Row className="d-flex justify-content-center mt-3">
          Please do not close this window.
        </Row>
      </AntModal>

      {contextModal}
    </div>
  );
}
